import { render } from "./ManageLiveClass.vue?vue&type=template&id=5ebeaeba&scoped=true"
import script from "./ManageLiveClass.vue?vue&type=script&lang=js"
export * from "./ManageLiveClass.vue?vue&type=script&lang=js"

import "./ManageLiveClass.vue?vue&type=style&index=0&id=5ebeaeba&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebeaeba"]])

export default __exports__